import type {Theme} from '#/alf/types'
import type {Badge} from '#/lib/badges/badgeTypes'
import {PersonCheck_Stroke2_Corner0_Rounded as PersonCheck} from '#/components/icons/Person'
import {ShieldCheck_Stroke2_Corner0_Rounded as ShieldCheck} from '#/components/icons/Shield'
import {Star_Filled_Corner0_Rounded as Star} from '#/components/icons/Star'
import {VerifiedCheck} from '#/components/icons/VerifiedCheck'
import {VerifierCheck} from '#/components/icons/VerifierCheck'

export function getBadgeVisual(badge: Badge, theme: Theme) {
  switch (badge.type) {
    case 'TELLUS_VERIFIED':
      return {Icon: VerifiedCheck, color: theme.palette.positive_500}
    case 'TELLUS_STAFF':
      return {Icon: Star, color: theme.palette.primary_600}
    case 'ORG_OFFICIAL':
      return {Icon: ShieldCheck, color: theme.palette.contrast_700}
    case 'ORG_MEMBER':
      return {Icon: PersonCheck, color: theme.palette.contrast_600}
    case 'BLUESKY_TRUSTED_VERIFIER':
      return {Icon: VerifierCheck, color: theme.palette.primary_500}
    case 'BLUESKY_VERIFIED':
    default:
      return {Icon: VerifiedCheck, color: theme.palette.primary_500}
  }
}
